var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUncategorizedBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2856 12.0436L1.42773 11.762L1.26525 30.1415L33.1232 30.4232L33.2856 12.0436Z",
    fill: "#FB8C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1785 4.97564C24.7057 4.79224 24.1689 5.02879 23.9856 5.50156L23.7063 6.22122L14.9396 2.81948L9.21432 17.5762L27.1683 25.4195L27.9453 24.8436L33.2438 11.1882L33.6712 10.0874L33.9504 9.36778C34.1338 8.89502 33.8973 8.35821 33.4245 8.17482L25.1785 4.97564Z",
    fill: "#37474F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1664 0.889206L13.8013 8.70752L25.246 16.5612L30.6111 8.74285L19.1664 0.889206Z",
    fill: "#D3F4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M11.5249 10.9923C11.463 11.1013 11.501 11.2393 11.61 11.3012L25.6848 19.3034C25.7938 19.3652 25.9318 19.3272 25.9937 19.2183C25.9937 19.2183 30.794 9.12575 30.685 9.06387L17.2772 1.33286C17.1688 1.27099 11.5249 10.9923 11.5249 10.9923Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5305 1.28477L10.8638 11.2532L25.3329 19.4784L30.9996 9.51001L16.5305 1.28477Z",
    fill: "#BCEDFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M25.7443 18.986L29.8403 8.66534L15.1291 2.29033L10.777 12.8987L25.7443 18.986Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.102 2.32446L9.74951 12.9329L25.1476 19.2506L29.5002 8.64219L14.102 2.32446Z",
    fill: "#E6FFFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M24.8177 5.33111C24.3449 5.14771 23.8081 5.38426 23.6247 5.85703L23.3454 6.57668L14.5788 3.17495L8.85349 17.9311L27.1684 25.4197L32.883 11.5437L33.3103 10.4429L33.5896 9.72325C33.773 9.25049 33.5364 8.71368 33.0637 8.53029L24.8177 5.33111Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4017 5.55244C23.9289 5.36905 23.3921 5.6056 23.2087 6.07837L22.9294 6.79802L14.1628 3.39687L8.43747 18.1531L27.1684 25.421L32.467 11.7656L32.8943 10.6648L33.1736 9.94518C33.357 9.47241 33.1204 8.93561 32.6477 8.75221L24.4017 5.55244Z",
    fill: "#546E7A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0219 9.76205L32.2732 11.7997L33.0313 10.4377L27.3003 8.21425L27.0219 9.76205Z",
    fill: "#FFD092"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.626 9.81586L28.564 9.97583L32.0821 11.3411L32.1442 11.1811L28.626 9.81586Z",
    fill: "#A67C52"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0552 9.19648L27.9932 9.35645L32.2178 10.9958L32.2799 10.8358L28.0552 9.19648Z",
    fill: "#A67C52"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1573 8.93183L28.0952 9.0918L32.3198 10.7312L32.3819 10.5712L28.1573 8.93183Z",
    fill: "#A67C52"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M27.6472 8.34644L33.0243 10.4462L27.7455 8.09313L27.6472 8.34644Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.166 9.91735L32.0587 10.0013C31.9667 10.0731 31.9503 10.2065 32.0221 10.2985L32.7425 11.2203C32.8143 11.3123 32.9477 11.3287 33.0397 11.2569L33.147 11.1729C33.239 11.1011 33.2554 10.9677 33.1836 10.8757L32.4632 9.95394C32.3914 9.86136 32.258 9.84495 32.166 9.91735ZM32.3859 10.0136L33.1064 10.9353C33.1452 10.9849 33.1363 11.0563 33.0868 11.0951L32.9795 11.179C32.9299 11.2178 32.8586 11.209 32.8198 11.1595L32.0993 10.2377C32.0605 10.1882 32.0694 10.1168 32.1189 10.078L32.2262 9.99402C32.2758 9.9558 32.3471 9.96463 32.3859 10.0136Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9613 9.52421L31.821 9.63425C31.7119 9.71937 31.6813 9.86259 31.752 9.95341L32.4475 10.8427L32.5247 10.7825L31.8292 9.89318C31.7921 9.846 31.8157 9.76246 31.8812 9.7115L32.0215 9.60146C32.087 9.5505 32.1731 9.54717 32.2102 9.59493L32.9057 10.4843L32.983 10.424L32.2874 9.53471C32.2168 9.4433 32.0704 9.43908 31.9613 9.52421Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M27.1684 25.421L14.1628 3.39687L8.43747 18.1531L27.1684 25.421Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M24.9246 9.71213L17.2544 12.7439L18.8072 16.6724L26.4774 13.6406L24.9246 9.71213Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6389 9.56736L16.9688 12.5991L18.5216 16.5276L26.1917 13.4958L24.6389 9.56736Z",
    fill: "#FBEE31"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M16.9687 12.6035L21.6881 13.3246L24.639 9.57196L21.5798 13.0519L16.9687 12.6035Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M21.5798 13.0519L24.639 9.57196L16.9687 12.6035L21.5798 13.0519Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5603 4.37709L0.877441 9.72656L8.14592 22.8829L17.8288 17.5334L10.5603 4.37709Z",
    fill: "#78909C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M11.2183 2.98716L1.29492 8.52588L8.92992 22.205L18.8533 16.6663L11.2183 2.98716Z",
    fill: "#241349"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8648 2.88755L0.941406 8.42627L8.57641 22.1054L18.4998 16.5667L10.8648 2.88755Z",
    fill: "#CFFFF6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M11.8003 2.3639L1.53613 7.24048L8.25839 21.3894L18.5225 16.5128L11.8003 2.3639Z",
    fill: "#241349"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4536 2.24134L1.18945 7.11792L7.91171 21.2668L18.1758 16.3902L11.4536 2.24134Z",
    fill: "#E6E6E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8255 4.18488L3.81299 7.5166L3.98338 7.87524L10.9959 4.54352L10.8255 4.18488Z",
    fill: "#BEBEBE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1682 4.90686L3.4585 8.56982L3.62889 8.92847L11.3386 5.2655L11.1682 4.90686Z",
    fill: "#BEBEBE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7352 10.3094L6.72266 13.6411L6.89305 13.9998L13.9056 10.668L13.7352 10.3094Z",
    fill: "#BEBEBE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0779 11.0316L6.36816 14.6946L6.53856 15.0532L14.2483 11.3903L14.0779 11.0316Z",
    fill: "#BEBEBE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9589 6.61275L8.73535 8.14429L8.90575 8.50293L12.1293 6.9714L11.9589 6.61275Z",
    fill: "#D9D9D9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3075 7.34591L9.08398 8.87744L9.25438 9.23608L12.4779 7.70455L12.3075 7.34591Z",
    fill: "#D9D9D9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6952 8.1628L9.47168 9.69434L9.64207 10.053L12.8656 8.52144L12.6952 8.1628Z",
    fill: "#D9D9D9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M13.06 8.93038L9.83643 10.4619L10.0068 10.8206L13.2304 9.28902L13.06 8.93038Z",
    fill: "#D9D9D9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89925 15.7987L6.95557 16.2471L8.60095 19.7102L9.54463 19.2619L7.89925 15.7987Z",
    fill: "#FBB03B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31331 15.1266L8.36963 15.575L10.015 19.0381L10.9587 18.5898L9.31331 15.1266Z",
    fill: "#FBB03B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7718 14.4359L9.82812 14.8843L11.4735 18.3474L12.4172 17.8991L10.7718 14.4359Z",
    fill: "#FBB03B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1844 13.7638L11.2407 14.2122L12.8861 17.6753L13.8298 17.227L12.1844 13.7638Z",
    fill: "#FBB03B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6439 13.0712L12.7002 13.5195L14.3456 16.9827L15.2893 16.5343L13.6439 13.0712Z",
    fill: "#FBB03B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0584 12.401L14.1147 12.8494L15.7601 16.3125L16.7038 15.8642L15.0584 12.401Z",
    fill: "#FBB03B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06478 18.2499L8.12109 18.6982L8.60111 19.7086L9.54479 19.2602L9.06478 18.2499Z",
    fill: "#F15A24"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1932 16.9796L9.24951 17.428L10.015 19.0392L10.9587 18.5909L10.1932 16.9796Z",
    fill: "#F15A24"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7601 16.5175L10.8164 16.9658L11.4734 18.3485L12.417 17.9002L11.7601 16.5175Z",
    fill: "#F15A24"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5687 14.5712L11.625 15.0195L12.8869 17.6755L13.8305 17.2271L12.5687 14.5712Z",
    fill: "#F15A24"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2376 14.3187L13.2939 14.7671L14.346 16.9814L15.2896 16.533L14.2376 14.3187Z",
    fill: "#F15A24"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2503 12.8029L14.3066 13.2512L15.7603 16.3108L16.7039 15.8624L15.2503 12.8029Z",
    fill: "#F15A24"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M20.3115 18.0964L8.89432 19.8432L6.94794 6.61752L17.8279 2.37099L20.3115 18.0964Z",
    fill: "#241349"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5085 2.02245L6.55322 3.75244L9.03635 19.477L19.9916 17.747L17.5085 2.02245Z",
    fill: "#FFE4E4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3152 3.23254L8.83008 4.41455L8.89055 4.79748L16.3757 3.61548L16.3152 3.23254Z",
    fill: "#BBBBBB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5374 11.7303L10.0522 12.9124L10.1127 13.2953L17.5979 12.1133L17.5374 11.7303Z",
    fill: "#BBBBBB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5901 5.776L10.105 6.95801L10.1655 7.34094L17.6506 6.15893L17.5901 5.776Z",
    fill: "#BBBBBB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6299 12.3136L9.40088 13.613L9.46135 13.996L17.6904 12.6965L17.6299 12.3136Z",
    fill: "#B8B8B8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9995 13.3794L11.5278 14.4014L11.5883 14.7843L18.06 13.7623L17.9995 13.3794Z",
    fill: "#C7C7C7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0737 14.1028L11.6021 15.1248L11.6625 15.5077L18.1342 14.4857L18.0737 14.1028Z",
    fill: "#808080"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2027 14.9233L11.731 15.9453L11.7914 16.3282L18.2631 15.3063L18.2027 14.9233Z",
    fill: "#808080"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3247 15.6946L11.853 16.7166L11.9135 17.0995L18.3852 16.0775L18.3247 15.6946Z",
    fill: "#808080"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4522 16.4961L11.9805 17.5181L12.0409 17.901L18.5126 16.879L18.4522 16.4961Z",
    fill: "#808080"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7425 9.27325L16.1103 9.53057L15.3946 9.01062L15.4319 8.95882L16.1267 9.46395L17.7325 9.2105L17.7425 9.27325Z",
    fill: "#666666"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87546 5.83126L8.04004 6.12109L8.06973 6.30909L9.90515 6.01925L9.87546 5.83126Z",
    fill: "#BBBBBB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2251 4.74312L15.3896 5.03296L15.4193 5.22096L17.2548 4.93112L17.2251 4.74312Z",
    fill: "#BBBBBB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1391 10.935L14.3037 11.2249L14.3334 11.4128L16.1688 11.123L16.1391 10.935Z",
    fill: "#BBBBBB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4116 10.4084L8.57617 10.6982L8.60586 10.8862L10.4413 10.5964L10.4116 10.4084Z",
    fill: "#BBBBBB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0497 14.3606L10.5117 14.4456L10.5967 14.9835L11.1346 14.8986L11.0497 14.3606Z",
    fill: "#ED1C24"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1688 15.1126L10.6309 15.1975L10.7158 15.7355L11.2538 15.6505L11.1688 15.1126Z",
    fill: "#FFAB00"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2982 15.9329L10.7603 16.0178L10.8452 16.5558L11.3832 16.4708L11.2982 15.9329Z",
    fill: "#FFD600"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4198 16.7022L10.8818 16.7871L10.9668 17.3251L11.5047 17.2401L11.4198 16.7022Z",
    fill: "#8CC63F"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5467 17.5054L11.0088 17.5903L11.0937 18.1283L11.6317 18.0433L11.5467 17.5054Z",
    fill: "#9575CD"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M34.76 14.0176L0.185059 13.7119L0.0338043 30.8211L34.6087 31.1268L34.76 14.0176Z",
    fill: "#0081AF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M0.185059 13.7119L0.0338043 30.8212L34.76 14.0176L0.185059 13.7119Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3637 21.7234L15.7993 21.6919L15.7867 23.1177L19.3511 23.1492L19.3637 21.7234Z",
    fill: "#E0E0E0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M15.7993 21.6919L15.7867 23.1177L19.3637 21.7234L15.7993 21.6919Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M19.5157 21.7247L21.1239 24.2343L15.7843 23.3854L19.5007 23.4183L19.5157 21.7247Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncategorizedBlue);
export default __webpack_public_path__ + "static/media/uncategorizedBlue.186759788b859cb825537a2ce095ece6.svg";
export { ForwardRef as ReactComponent };